// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bxnv","field":"styles_field__3IfZV","fieldCol":"styles_fieldCol__1K8t1","diffCol":"styles_diffCol__38ME7","diff":"styles_diff__2XfiB"};